import WeightReport from './WeightReport';

export default [WeightReport];
